"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProcessingWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_model_1 = require("@athena-portal/journey-model");
var portal_core_1 = require("@ferry/portal-core");
var PaymentProcessingWidget = /** @class */ (function (_super) {
    __extends(PaymentProcessingWidget, _super);
    function PaymentProcessingWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.processingText = _this.getSetting("processingText", undefined);
        if (!_this.processingText) {
            throw Error("".concat(_this.props.question.type, " widget is missing 'processingText' setting"));
        }
        return _this;
    }
    PaymentProcessingWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "panel panel-processing", children: [(0, jsx_runtime_1.jsx)("h1", { className: "panel-heading", children: this.processingText }), (0, jsx_runtime_1.jsxs)("h2", { className: "text-center h5", children: ["Once your ", portal_core_1.resourcesHelper.THEME_NAME, " insurance is set up, you will see a payment confirmation screen and you will receive a confirmation email."] }), (0, jsx_runtime_1.jsx)("p", { children: "Please wait..." }), (0, jsx_runtime_1.jsx)("p", { children: "Don't refresh or close your browser..." }), (0, jsx_runtime_1.jsx)("img", { className: "car", src: "/img/Flourishes-5.svg" })] }));
    };
    PaymentProcessingWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "processingText", type: journey_model_1.TypeDescriptions.String },
        ]),
        __metadata("design:paramtypes", [Object])
    ], PaymentProcessingWidget);
    return PaymentProcessingWidget;
}(plugin_journey_1.WidgetBase));
exports.PaymentProcessingWidget = PaymentProcessingWidget;
//# sourceMappingURL=PaymentProcessingWidget.js.map